(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/pages/digital-tickets/components/digital-tickets-form/components/billing-information/billing-information.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/pages/digital-tickets/components/digital-tickets-form/components/billing-information/billing-information.js');
"use strict";


const {
  UPDATE_BILLING_INFORMATION,
  RECEIVE_COMPANY_DETAILS,
  CLEAR_STATE
} = svs.ticket_partner.digitalTickets.actions;
const {
  REFERENCE,
  ADDRESS,
  ZIP,
  CITY
} = svs.ticket_partner.digitalTickets.constants.names;
const {
  useContext,
  useEffect,
  useState
} = React;
const {
  GridCol,
  GridRow
} = svs.ui.ReactGrid;
const {
  COUNTRYID
} = svs.ticket_partner.sharedComponents.input.constants.names;
const {
  ZipCodeInput,
  AdressInput,
  CityInput,
  AcceptTerms,
  CountryDropdown
} = svs.ticket_partner.sharedComponents.input;
const {
  Reference,
  MessageInput,
  InvoiceMessageInput
} = svs.ticket_partner.digitalTickets.digitalTicketsForm.billingInformation.components;
const {
  HEADER
} = svs.ticket_partner.digitalTickets.digitalTicketsForm.billingInformation.constants.TEXTS;
const BillingInformation = () => {
  const {
    state,
    dispatch
  } = useContext(svs.ticket_partner.DigitalTicketsContext);
  const {
    isLoggedIn,
    companyDetailsPromise
  } = svs.ticket_partner.useUserContext();
  const [companyName, setCompanyName] = useState(null);
  useEffect(async () => {
    let stateCleared = false;
    if (isLoggedIn) {
      var _companyDetails$addre;
      svs.ui.loader.show();
      const {
        companyDetails
      } = await companyDetailsPromise;
      if (state.partnerId !== companyDetails.partnerId) {
        dispatch({
          type: CLEAR_STATE
        });
        stateCleared = true;
      }
      const billingAdress = (_companyDetails$addre = companyDetails.addresses) === null || _companyDetails$addre === void 0 ? void 0 : _companyDetails$addre.find(_ref => {
        let {
          addressType
        } = _ref;
        return addressType.toLowerCase() === 'billing';
      });
      setCompanyName(companyDetails === null || companyDetails === void 0 ? void 0 : companyDetails.companyName);
      if (billingAdress) {
        const {
          city,
          zip,
          address1
        } = billingAdress;
        const setValue = (field, resVal) => stateCleared ? resVal : state.billingInformation[field] || resVal || '';
        dispatch({
          type: RECEIVE_COMPANY_DETAILS,
          payload: {
            partnerId: companyDetails.partnerId,
            reference: setValue(REFERENCE, companyDetails.contactPerson),
            address1: setValue(ADDRESS, address1),
            city: setValue(CITY, city),
            zip: setValue(ZIP, zip)
          }
        });
      }
      svs.ui.loader.hide();
    }
  }, [isLoggedIn, companyDetailsPromise]);
  const handleOnChange = _ref2 => {
    let {
      target
    } = _ref2;
    dispatch({
      type: UPDATE_BILLING_INFORMATION,
      payload: {
        field: target.id,
        value: target.value
      }
    });
  };
  const handleOnChangeCheckBox = _ref3 => {
    let {
      target
    } = _ref3;
    dispatch({
      type: UPDATE_BILLING_INFORMATION,
      payload: {
        field: target.id,
        value: target.checked
      }
    });
  };
  const handleDropDownChange = e => {
    dispatch({
      type: UPDATE_BILLING_INFORMATION,
      payload: {
        field: COUNTRYID,
        value: parseInt(e.target.value, 10)
      }
    });
  };
  return React.createElement("div", {
    className: "margin-bottom-2"
  }, React.createElement(GridRow, null, React.createElement("h2", null, HEADER), companyName && React.createElement("h3", null, companyName)), React.createElement(GridRow, null, React.createElement(GridCol, {
    am: 6,
    sm: 12
  }, React.createElement(Reference, {
    handleChange: handleOnChange,
    state: state.billingInformation
  })), React.createElement(GridCol, {
    am: 6,
    sm: 12
  }, React.createElement(AdressInput, {
    handleChange: handleOnChange,
    state: state.billingInformation
  }))), React.createElement(GridRow, null, React.createElement(GridCol, {
    am: 3,
    sm: 12
  }, React.createElement(ZipCodeInput, {
    handleChange: handleOnChange,
    state: state.billingInformation
  })), React.createElement(GridCol, {
    am: 4,
    sm: 12
  }, React.createElement(CityInput, {
    handleChange: handleOnChange,
    state: state.billingInformation
  })), React.createElement(GridCol, {
    am: 5,
    sm: 12
  }, React.createElement(CountryDropdown, {
    handleDropDownChange: handleDropDownChange,
    state: state.billingInformation
  }))), React.createElement(GridRow, {
    className: "padding-top-2"
  }, React.createElement(InvoiceMessageInput, {
    handleChange: handleOnChange,
    state: state.billingInformation
  })), React.createElement(GridRow, {
    className: "padding-top-2"
  }, React.createElement(MessageInput, {
    handleChange: handleOnChange,
    state: state.billingInformation
  })), React.createElement(GridRow, {
    className: "padding-top-1"
  }, React.createElement(AcceptTerms, {
    handleOnChange: handleOnChangeCheckBox,
    state: state.billingInformation
  })));
};
svs.ticket_partner.digitalTickets.digitalTicketsForm.billingInformation.BillingInformation = BillingInformation;

 })(window);